module.exports = __webpack_public_path__ + "img/white-logo.f9ee3a37.svg";